import { toast } from 'react-toastify';
import _ from 'lodash';
export const REDUCER_GENERIC = "GENERIC"

var template = (templateName) => (state = {past: [], data: [], isLoading: false, dialogClose: false}, action) => {
    templateName = templateName.toUpperCase();
    switch (action.type) {
    case templateName: {
        state.past = []
        if(typeof action.data === 'object') {
            state.past.push({
                time: new Date(),
                data: _.clone(action.data)
            })
        }
        state = {...state, ...action, isLoading: false, message: undefined}
        return state
    }
    case templateName+'_RESET' : {
        console.log("templateName", templateName)
        return {past: [], data: [], isLoading: false, dialogClose: false}
    }
    case templateName+'_LOADING' : {
        state = {...state, isLoading: action.isLoading}
        return state
    }
    case templateName+'_DIALOG' : {
        var doOpen = true
        if(state.dialogOpen) {
            doOpen = false
        }
        state = {...state, dialogOpen: doOpen}
        return state
    }
    case templateName+'_REVERSE' : {
        //var pastData = _.reverse(state.past)
        if(state.past[action.goToKey]) {
            _.reverse(state.past)
            state.data = state.past[action.goToKey].data
            _.reverse(state.past)
            state = {...state, ...action}
            toast.success("Inhalt wurde wiederhergestellt", {})
        }
        return state
    }
    case templateName+'_ADD' : {
        if(state.data === undefined && action.doSingle === undefined) {
            state.data = []
        }

        if(action.doSingle === undefined) {
            if(action.doAdd !== undefined) {
                state.data = [
                    ...state.data.slice(0, -1),
                    action.newData,
                ]
            } else {
                if(action.addAsc === undefined) {
                    state.data = [
                        action.newData,
                        ...state.data,
                    ]
                } else {
                    state.data = [
                        ...state.data,
                        action.newData,
                    ]
                }
            }
        } else {
            state.data = action.newData
        }

        state.count += 1
        state.expanded = action.newData.id
        state = {...state, ...action}
        return state
    }
    case templateName+'_DELETE' : {
        if(state.data.filter !== undefined) {
            state.data = state.data.filter((item) => {
                if(item.id === action.deleteId) {
                    state.count -= 1
                    return false
                }
                return true
            })
        }
        state = {...state, ...action}
        return state
    }
    case templateName+'_PUT' : {
        if(state.putLoading === undefined) {
            state.putLoading = {}
        }
        state.putLoading[action.id] = action.isLoading
        if(!_.isEmpty(action.putData)) {
            if(!state.past) {
                state.past = []
            }
            if(state.isLoading && state.past[state.past.length-1] && state.data !== state.past[state.past.length-1].data) {
                state.past.push({
                    time: new Date(),
                    data: _.clone(state.data)
                })
                if(state.past.length > 20) {
                    state.past = state.past.slice(1, -1)
                }
            }
            if(state.data.length !== undefined && state.data.length > 0) {
                state.data.forEach((item, k) => {
                    if(item.id === action.putData.id) {
                        item = action.putData
                        state.data[k] = action.putData
                    }
                })
            } else {
                state.data = action.putData
            }
            
        }
        state = {...state, ...action}
        return state
    }
    case templateName+'_ERROR' : {
        state = {...state, isLoading: false, message: action.message}
        toast.error(action.message, {})
        return state
    }
    case templateName+'_RELOAD' : {
        state = {...state, ...action, isLoading: action.isLoading}
        return state
    }
    default:
        return state
    }
}
 
export default template



// WEBPACK FOOTER //
// ./src/Redux/Reducers/template.jsx